import { useAuction } from '@autobid/ui/composables/useAuction'
import { useAuctionPagesLink } from '@autobid/ui/composables/useAuctionPagesLink'

export function useAuctionI18nSwitcher(auctionId: number | undefined) {
  const { name } = useRoute()
  const { auction } = useAuction(auctionId)
  const { getLink } = useAuctionPagesLink()

  const getAuctionPageLink = (lang: string) => {
    if (!auctionId || !auction.value) {
      return null
    }

    const [baseRouteName] = String(name).split('___')
    const auctionSlug
      = auction.value.allSlugs[lang.toUpperCase()]
        ?? auction.value.allSlugs.default

    if (!auctionSlug) {
      return null
    }

    const linkProps = {
      slug: auctionSlug,
      lang,
    }

    switch (baseRouteName) {
      case 'auction-slug':
        return getLink({
          page: 'car-list',
          ...linkProps,
        })
      case 'auction-current-slug':
        return getLink({
          page: 'current',
          ...linkProps,
        })
      default:
        return null
    }
  }

  return { getAuctionPageLink }
}
